import { SVGAttributes } from "react";

export const ContentBlockNoborderWIPIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.707 1.707a1 1 0 10-1.414 1.414l.212.212A2.986 2.986 0 001 5v6a3 3 0 003 3h8c.056 0 .112-.002.167-.005l.44.44a1 1 0 001.507-1.307A2.99 2.99 0 0015 11V5a3 3 0 00-3-3H4a3 3 0 00-.871.129l-.422-.422zm.306 3.134A1.008 1.008 0 003 5v6a1 1 0 001 1h6.172l-7.16-7.159zm9.694 6.866L5 4h7a1 1 0 011 1v6a.997.997 0 01-.293.707z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          x={4.929}
          y={3.515}
          width={22}
          height={2}
          rx={1}
          transform="rotate(45 4.929 3.515)"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.636 4.222a1 1 0 10-1.414 1.414l.172.172A1.991 1.991 0 004 7v10a2 2 0 002 2h11.586l.778.778a1 1 0 101.414-1.414l-.172-.172c.248-.333.394-.745.394-1.192V7a2 2 0 00-2-2H6.414l-.778-.778zM6 7.414V17h9.586L6 7.414zm12 9.172L8.414 7H18v9.586z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
ContentBlockNoborderWIPIcon.displayName = "ContentBlockNoborderWIPIcon";
